import { render, staticRenderFns } from "./SampleRequest.vue?vue&type=template&id=76222d69&"
import script from "./SampleRequest.vue?vue&type=script&lang=js&"
export * from "./SampleRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports